import { ActionBase } from '../../../core/store/action/ActionBase';

export const CLEAR_VOCABULARY_CACHE = '[Vocabulary] Clear Vocabulary Cache';

export class ClearVocabularyCacheAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CLEAR_VOCABULARY_CACHE;
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/ClearVocabularyCacheAction.ts